module.exports = __webpack_public_path__ + "static/media/25_tn.1174bf8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/25_tn.jpg
// module id = 661
// module chunks = 0